import React, { useState, useEffect } from "react";
import {
  Text,
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  Input,
  useToast,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import firebase from "../utils/firebase";
import { withRouter } from "react-router-dom";

function Login({ history }) {
  const { register, handleSubmit, errors, getValues } = useForm();
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();

  const onSubmit = async (data) => {
    try {
      const response = await firebase
        .auth()
        .signInWithEmailAndPassword(data.email, data.password);
      toast({
        title: "Welcome Back! Logging you in...",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
    } catch (err) {
      toast({
        title: "Sorry, you could not login.",
        description: err.message,
        status: "error",
        duration: 2000,
        isClosable: true,
      });
    }
  };

  const onSignUp = async () => {
    try {
      const response = await firebase
        .auth()
        .createUserWithEmailAndPassword(
          getValues("email"),
          getValues("password")
        );
      toast({
        title: "Your PeriodFriend Account is Successfully Created",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
    } catch (err) {
      toast({
        title: "Your PeriodFriend Account could not be created.",
        description: err.message,
        status: "error",
        duration: 2000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        history.push("/");
      }
    });
  }, []);

  return (
    <Flex flexDirection="column" maxW="lg" m="auto" my={20}>
      <Text fontSize="2xl" my={10}>
        Hi! Sign in to{" "}
        <Text fontSize="2xl" as="em">
          PeriodFriend
        </Text>
      </Text>
      <Text>
        {" "}
        Please Sign in Using Your Email Account. If you don't have one yet,
        please create one by clicking sign up instead.{" "}
      </Text>
      <Box as={"form"} onSubmit={handleSubmit(onSubmit)}>
        <FormControl my={2}>
          <Input
            placeholder="Email Address"
            {...register("email", { required: true })}
            my={2}
          />
        </FormControl>

        <FormControl my={2}>
          <Input
            placeholder="Password"
            type="password"
            {...register("password", { required: true })}
            my={2}
          />
        </FormControl>

        <Button type="submit" w="100%" my={4} isLoading={isLoading}>
          SIGN IN
        </Button>

        <Button w="100%" mt={2} onClick={onSignUp}>
          Sign Up
        </Button>
      </Box>
    </Flex>
  );
}

export default withRouter(Login);
